import styled from 'styled-components';
import { Link } from 'react-router';
import { media } from 'style-utils';
import { NitroIcon } from 'nitro-components';

// Menu.js
export const DesktopHeader = styled.div`
  padding: 8px 20px;
  background: ${props => props.theme.color.primary};
  display: flex;
  justify-content: space-between;
  width: ${props => props.width};
  height: 52px;
  align-self: flex-end;
`;

export const MobileHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: ${props =>
    props.showHeaderBorder ? '1px solid #303958' : null};
`;

export const HeaderTitle = styled.span`
  font-family: ${props => props.theme.font.bold};
  color: white;
  align-items: center;
  font-size: 13px;
  margin-left: 20px;
`;

export const HeaderIcon = styled(NitroIcon)`
  padding: 10px 0;

  ${media.mobileTablet`
    padding: 16px 20px;
    background: ${props => props.theme.color.primary};
  `}
`;

export const HeaderLogo = styled(Link)`
  cursor: pointer;
  display: inline-flex;
  width: 170px;
`;

export const MenuContent = styled.div`
  flex-grow: 1;
  justify-content: flex-start;
  overflow: auto;
`;

export const MenuContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  background: #0b223d;
  width: ${props => (props.open ? props.openedWidth : props.closedWidth)};
  top: 0;
  bottom: 0;
  left: 0;
  transition: width 450ms;
  z-index: 1300;
  font-family: ${props => props.theme.font.light};
  overflow: hidden;

  // Fixes incorrect svg heights
  span {
    display: inline-flex;
  }
`;
//
export const MenuRow = styled.div`
  color: white;
  display: flex;
  font-size: 13px;
  align-items: start;
  border-bottom: 1px solid #303958;
  overflow: hidden;
  opacity: ${props => (props.active ? 1 : 0.6)};
  border-right-style: ${props => (props.active ? 'solid' : null)};
  border-right-width: 4px;
  ${media.mobileTablet`
    border-right-width: 6px;
  `}
  border-right-color: ${props => props.theme.color.primary};
  flex-direction: column;

  :hover {
    opacity: 1;
  }
`;

export const MenuRowInternal = styled.div`
  text-decoration: none;
  display: flex;
  width: ${props => props.width};
  padding: 15px 24px;
  background: ${props => (props.active ? '#051629' : null)};
`;

export const MenuRowHeader = styled(MenuRowInternal)`
  cursor: pointer;
  align-items: center;
  font-family: ${props => props.theme.font.medium};

  :hover {
    background: #051629;
  }
`;

export const MenuLink = styled(Link)`
  text-decoration: none;
  color: white;
`;



// WEBPACK FOOTER //
// ./src/components/common/Menu/Sidebar/styles.js